import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { format } from 'date-fns';

export default function TourSlots({ tourSlots = [] }) {
  // If no tour slots are available, don't render anything
  if (!tourSlots || tourSlots.length === 0) return null;
  
  // Format date and time for display
  const formatSlotTime = (dateTime) => {
    const date = new Date(dateTime);
    return format(date, 'h:mm a');
  };
  
  const formatSlotDate = (dateTime) => {
    const date = new Date(dateTime);
    return format(date, 'EEEE, MMMM d');
  };
  
  // Group slots by date
  const slotsByDate = tourSlots.reduce((acc, slot) => {
    const date = formatSlotDate(slot.start_at);
    if (!acc[date]) acc[date] = [];
    acc[date].push(slot);
    return acc;
  }, {});
  
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-lg font-medium">Available Tour Times</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-6">
          {Object.entries(slotsByDate).map(([date, slots], dateIndex) => (
            <div key={dateIndex} className="space-y-3">
              <h4 className="font-medium text-gray-700">{date}</h4>
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
                {slots.map((slot, index) => (
                  <Button 
                    key={index} 
                    variant="outline" 
                    className="justify-center hover:bg-blue-50 hover:text-blue-700 hover:border-blue-200"
                  >
                    {formatSlotTime(slot.start_at)}
                  </Button>
                ))}
              </div>
            </div>
          ))}
          
          <div className="text-center pt-2">
            <Button className="bg-blue-600 hover:bg-blue-700">
              Schedule Your Tour
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
